/* eslint-disable react-hooks/exhaustive-deps */
// Hooks

import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useRecordTypes } from '../../../../../src/views/RecordType/hooks/useRecordTypes';

// Styles
import {
  icon_column_style,
  individual_column_style,
  individual_icon_header_style,
  individual_header_style
} from '../../../../assets/styles/table_custom_style';

// Componentes
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import { Row, Button } from 'reactstrap';
import { TagRecordType } from '../../../../../src/views/fieldConfigs/list/components/TableProtocolFields/TagRecordType/TagRecordType';
import ReactLoader from 'components/Loader';

const TableLostReasonFields = ({ fields }) => {
  const history = useHistory();
  const handleUpdate = (fieldData) => {
    const { id } = fieldData;

    history.push(`lostReason/form/${id}`);
  };

  const { recordTypes: leadRecordTypes, isLoadingRecordTypes: isLoadingLead } =
    useRecordTypes('LEAD');
  const {
    recordTypes: opportunityRecordTypes,
    isLoadingRecordTypes: isLoadingOpportunity
  } = useRecordTypes('OPPORTUNITY');
  const [recordTypesNames, setRecordTypesNames] = useState({});

  useEffect(() => {
    const leadNames = {};
    const opportunityNames = {};

    if (leadRecordTypes && leadRecordTypes.length) {
      leadRecordTypes.forEach((record) => {
        leadNames[record.id] = record.name;
      });
    }

    if (opportunityRecordTypes && opportunityRecordTypes.length) {
      opportunityRecordTypes.forEach((record) => {
        opportunityNames[record.id] = record.name;
      });
    }

    setRecordTypesNames({ LEAD: leadNames, OPPORTUNITY: opportunityNames });
  }, [leadRecordTypes, opportunityRecordTypes]);

  return (
    <>
      {fields &&
        !isLoadingLead &&
        !isLoadingOpportunity &&
        Object.keys(recordTypesNames).length && (
          <ToolkitProvider
            data={fields || []}
            keyField="id"
            columns={[
              {
                dataField: 'name',
                text: 'Nome',
                sort: true,
                style: individual_column_style,
                headerStyle: individual_header_style
              },
              {
                dataField: 'description',
                text: 'Descrição',
                sort: true,
                style: individual_column_style,
                headerStyle: individual_header_style
              },
              {
                dataField: 'isActive',
                text: 'Status do Motivo',
                sort: true,
                style: individual_column_style,
                headerStyle: individual_header_style,
                formatter: (_, row) => {
                  const isActive = row.isActive === true ? 'Ativo' : 'Inativo';
                  return isActive && <TagRecordType>{isActive}</TagRecordType>;
                }
              },
              {
                dataField: 'entity',
                text: 'Tipo',
                sort: true,
                style: individual_column_style,
                headerStyle: individual_header_style,
                formatter: (_, row) => {
                  return row.entity === 'LEAD' ? 'Lead' : 'Oportunidade';
                }
              },
              {
                dataField: 'recordTypes',
                text: 'Tipos de registros',
                sort: true,
                style: individual_column_style,
                headerStyle: individual_header_style,
                formatter: (_, row) => {
                  return row.recordTypesConfig.map((record) => {
                    const recordTypeName =
                      row.entity === 'LEAD'
                        ? recordTypesNames.LEAD[record.recordTypeId]
                        : row.entity === 'OPPORTUNITY'
                        ? recordTypesNames.OPPORTUNITY[record.recordTypeId]
                        : null;

                    return (
                      recordTypeName && (
                        <TagRecordType key={record.recordTypeId}>
                          {recordTypeName}
                        </TagRecordType>
                      )
                    );
                  });
                }
              },

              {
                dataField: 'edit',
                style: icon_column_style,
                headerStyle: individual_icon_header_style,
                text: 'Editar',
                formatter: (_, row) => {
                  return (
                    <Button
                      title={'Clique aqui para editar'}
                      size="sm"
                      color="info"
                      onClick={() => handleUpdate(row)}
                    >
                      <li className="fas fa-edit"></li>
                    </Button>
                  );
                }
              }
            ]}
          >
            {(props) => (
              <div className="py-4 table-responsive">
                {props.loading ? (
                  <Row className="justify-content-md-center">
                    <ReactLoader />
                  </Row>
                ) : (
                  <BootstrapTable
                    {...props.baseProps}
                    bootstrap4={true}
                    bordered={false}
                    classes="align-items-center"
                  />
                )}
              </div>
            )}
          </ToolkitProvider>
        )}
    </>
  );
};

export { TableLostReasonFields };
